import { MemorialTree } from '../../../types'
import centsToDollars from '../../../utils/centsToDollars'

const MemorialTreeModel = {
  productsSubtotalInDollars: (products: MemorialTree[]): number => {
    const subtotalInCents = products.reduce(
      (subtotal: number, product: MemorialTree) =>
        (subtotal += product.quantity * product.price_in_cents),
      0,
    )

    return parseFloat(centsToDollars(subtotalInCents))
  },
  productsQuantity: (products: MemorialTree[]): number =>
    products.reduce((quantity: number, product: MemorialTree) => (quantity += product.quantity), 0),
  toGaItem: (product: MemorialTree): Gtag.Item => ({
    item_id: product.product_id,
    item_name: product.name,
    price: product.price_in_cents / 100.0,
    quantity: product.quantity,
  }),
}

export default MemorialTreeModel
